<div class="container-fluid px-2 mt-3">
  <div class="row">
    <div class="col-12">
      <form class="row g-3">
        <!-- Address Line 1 -->
        <div class="col-12 col-md-5">
          <app-input 
            [inputName]="'AddressLine1'" 
            [inputType]="'text'" 
            [inputId]="'AddressLine1'"
            [inputValue]="addressDetails.addressLine1" 
            [inputLabel]="'Address Line 1'"
            [inputPlaceholder]="''" 
            (inputValueEmit)="addressDetails.addressLine1=$event"
            [isRequired]="false">
          </app-input>
        </div>

        <!-- Address Line 2 -->
        <div class="col-12 col-md-5">
          <app-input 
            [inputName]="'AddressLine2'" 
            [inputType]="'text'" 
            [inputId]="'AddressLine2'"
            [inputValue]="addressDetails.addressLine2" 
            [inputLabel]="'Address Line 2'"
            [inputPlaceholder]="''" 
            (inputValueEmit)="addressDetails.addressLine2=$event"
            [isRequired]="false">
          </app-input>
        </div>

        <!-- Country -->
        <div class="col-12 col-md-5">
          <app-dropdown 
            [options]="dropdownnData.countryDropdown" 
            [labelName]="'Country'"
            [selectedOption]="addressDetails.country"
            [selectedId]="addressDetails.countryId"
            (dropdownValueEmit)="onChangeCountry($event)">
          </app-dropdown>
        </div>

        <!-- State -->
        <div class="col-12 col-md-5">
          <app-dropdown 
            [options]="filterStateDropdown" 
            [labelName]="'State'"
            [selectedOption]="addressDetails.state"
            [selectedId]="addressDetails.stateId"
            (dropdownValueEmit)="onChangeState($event)">
          </app-dropdown>
        </div>

        <!-- District -->
        <div class="col-12 col-md-5">
          <app-dropdown 
            [options]="filterDestrictDropdown" 
            [labelName]="'District'" 
            [selectedOption]="addressDetails.district"
            [selectedId]="addressDetails.districtId"
            (dropdownValueEmit)="onChangeDistrict($event)">
          </app-dropdown>
        </div>

        <!-- Taluka -->
        <div class="col-12 col-md-5">
          <app-dropdown 
            [labelName]="'Taluka'" 
            [selectedOption]="addressDetails.taluka"
            [selectedId]="addressDetails.taluka"
            (dropdownValueEmit)="addressDetails.taluka = $event">
          </app-dropdown>
        </div>

        <!-- Pincode -->
        <div class="col-12 col-md-5">
          <app-input 
            [onlyNumbers]="true"
            [inputName]="'Pincode'" 
            [inputType]="'text'" 
            [inputId]="'Pincode'"
            [inputValue]="addressDetails.pinCode" 
            [inputLabel]="'Pincode'" 
            [inputPlaceholder]="''"
            (inputValueEmit)="addressDetails.pinCode=$event" 
            [isRequired]="false">
          </app-input>
        </div>

      </form>
    </div>
  </div>
</div>
